import { Component, Input, OnInit } from '@angular/core';
import { SbModalState } from '../modal-state.service';
import { MultiFreetextFilteredOptions } from '../modal.model';
import { UtilService } from '../../../util.service';

@Component({
  selector: 'sb-multi-select-modal',
  templateUrl: './sb-multi-select-modal.component.html',
  styleUrls: ['./sb-multi-select-modal.component.scss'],
  standalone: false,
})
export class SbMultiSelectModalComponent implements OnInit {
  @Input() templateId: string;
  options: MultiFreetextFilteredOptions<string>;
  selectedOptions: string[] = [];

  ngOnInit() {
    this.options = this.state.options.get(this.templateId) as MultiFreetextFilteredOptions<string>;
    this.selectedOptions = this.options.initial ?? [];
  }

  constructor(
    private state: SbModalState,
    public util: UtilService
  ) {}

  ok() {
    if (this.checkOkEnabled()) {
      this.state.modals.get(this.templateId).close({
        value: this.selectedOptions,
        cancel: false,
      });
    }
  }

  checkOkEnabled() {
    return this.selectedOptions !== null;
  }

  cancel() {
    this.state.modals.get(this.templateId).close({
      value: null,
      cancel: true,
    });
  }

  clear() {
    this.selectedOptions = [];
  }

  addToSelection(item: string) {
    if (!this.selectedOptions.includes(item)) {
      this.selectedOptions.push(item);
    }
  }

  removeFromSelection(index: number) {
    this.selectedOptions.splice(index, 1);
  }
}
